import React from 'react';
import Select from 'react-select';

// https://react-select.com/

export const SelectList = ({
    alternateStyle,
    components,
    disabled,
    isClearable,
    isMulti,
    options,
    onChange,
    inputOnChange,
    placeholder,
    value,
    inputValue,
    defaultValue,
    isSearchable,
    error,
    secProfileList = false,
}) => {
    return (
        <Select
            components={components}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            backspaceRemovesValue={false}
            isOptionDisabled={(option) => option.disabled}
            menuPlacement="auto"
            onChange={onChange}
            onInputChange={inputOnChange}
            options={options}
            placeholder={placeholder}
            styles={
                alternateStyle
                    ? alternateStyle === true
                        ? alternateStyles
                        : alternate2Styles
                    : selectStyles
            }
            value={value}
            inputValue={inputValue}
            defaultValue={defaultValue}
            isSearchable={isSearchable}
            error={error}
            secProfileList={secProfileList}
        />
    );
};

const selectStyles = {
    option: (styles, { isSelected, isFocused }) => ({
        ...styles,
        padding: '12px 24px',
        fontSize: '16px',
        lineHeight: '20px',
        fontFamily: 'InterRegular',
        color: isSelected ? '#008DC2' : '#63686B',
        backgroundColor: isSelected || isFocused ? '#A4DEFF' : undefined,
        cursor: 'pointer',
    }),
    menu: (styles) => ({
        ...styles,
        padding: '4px 0',
        borderRadius: '8px',
        boxShadow: '0px 0px 20px rgba(0, 84, 236, 0.1)',
    }),
    noOptionsMessage: (styles) => ({
        ...styles,
        fontFamily: 'InterRegular',
        fontSize: '16px',
        lineHeight: '20px',
    }),
    control: (styles, { isFocused, selectProps }) => ({
        ...styles,
        fontFamily: 'InterRegular',
        padding: '6px 12px',
        border: selectProps.error
            ? '1px solid #EC1919'
            : isFocused
            ? '1px solid #A4DEFF'
            : '1px solid #B5BCBE', // revisit this maybe?
        '&:hover': {
            borderColor: selectProps.error ? '#EC1919' : '#A4DEFF',
        },
        boxShadow: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        display: 'none',
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: '#231D27',
    }),
    indicatorsContainer: (styles, state) => ({
        ...styles,
        transition: 'all 0.2s ease',
        'div:last-of-type': {
            transition: 'all 0.2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        },
        display: 'flex',
    }),
    // SPECIFIC STYLES FOR THE USER PAGE. MANAGED VIA SECPROFILELIST PROP
    multiValueLabel: (styles, { data, selectProps }) => ({
        ...styles,
        padding:
            selectProps.secProfileList && data.label === 'Admin' ? '3px 6px' : '3px 3px 3px 0px',
    }),
    multiValueRemove: (styles, { data, selectProps }) => ({
        ...styles,
        display: selectProps.secProfileList && data.label === 'Admin' && 'none',
    }),
};

const alternateStyles = {
    ...selectStyles,
    control: (styles) => ({
        ...styles,
        fontFamily: 'PoppinsMedium',
        fontSize: '14px',
        lineHeight: '20px',
        color: '#231D27',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: 'none',
        boxShadow: 'none',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        minHeight: '44px',
    }),
    placeholder: (styles) => ({
        ...styles,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#B5BCBE',
    }),
    indicatorsContainer: (styles, { isDisabled, selectProps }) => ({
        ...styles,
        display: isDisabled ? 'none' : 'flex',
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : '',
        transition: 'all 0.2s ease',
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: '0px 12px',
    }),
};

const alternate2Styles = {
    ...selectStyles,
    control: (styles) => ({
        ...styles,
        fontFamily: 'PoppinsMedium',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#231D27',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: 'none',
        boxShadow: 'none',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        minHeight: '44px',
    }),
    placeholder: (styles) => ({
        ...styles,
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#B5BCBE',
    }),
    indicatorsContainer: (styles, { isDisabled, selectProps }) => ({
        ...styles,
        display: isDisabled ? 'none' : 'flex',
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : '',
        transition: 'all 0.2s ease',
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: 0,
    }),
};
